/* eslint-disable no-console */

import { register } from 'register-service-worker'

const isLocalDev =
  typeof location !== 'undefined' &&
  (location.hostname === 'localhost' || location.hostname === '127.0.0.1')

// 生产环境必须注册 SW，PWA 的 beforeinstallprompt 才会出现；
// 本地 localhost 也注册，便于联调安装提示（需 HTTPS 的线上环境仍按浏览器规则）。
const shouldRegister =
  process.env.NODE_ENV === 'production' || isLocalDev

if (shouldRegister) {
  register(`${process.env.BASE_URL}service-worker.js`, {
    ready() {
      console.log(
        'App is being served from cache by a service worker.\n' +
          'For more details, visit https://goo.gl/AFskqB'
      )
    },
    registered() {
      console.log('Service worker has been registered.')
    },
    cached() {
      console.log('Content has been cached for offline use.')
    },
    updatefound() {
      console.log('New content is downloading.')
    },
    updated() {
      console.log('New content is available; please refresh.')
    },
    offline() {
      console.log(
        'No internet connection found. App is running in offline mode.'
      )
    },
    error(error) {
      console.error('Error during service worker registration:', error)
    }
  })
}
